import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'alarm-dialog',
    templateUrl: './alarm-dialog.component.html',
    styleUrls: ['./alarm-dialog.component.scss'],
    standalone: false
})


export class AlarmDialogComponent implements OnInit {
    @Input() public items: any[] = [];

    public filteredItems: string = "";

    constructor(
        public dialogRef: MatDialogRef<AlarmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        this.items = this.data.items;
    }

    closeDialog(): void {
        this.dialogRef.close();
    }
}